<div class="container">
    <div class="card">
        <div class="card-body">
            <div class="panel panel-primary">
                <div class="panel-heading custom-panel">
                    <div class="titulo-painel-left">
                        <h2>Cancelamento da Marcação</h2>
                    </div>
                </div>
            </div>

            <div>
                <form [formGroup]="formularioInformacaoCancelamento" (keydown.enter)="$event.preventDefault()">
                    <div class="form-group">
                        <mat-divider fxFlex="1 0"></mat-divider>
                    </div>

                    <div class="form-row">
                        <mat-form-field class="form-group col-lg-8 col-md-8 col-sm-8 col-12">
                            <mat-label>Funcionário Cancelamento</mat-label>
                            <input matInput value="Funcionário Cancelamento" class="form-control"
                                id="loginUserCancelamento" name="loginUserCancelamento"
                                formControlName="loginUserCancelamento" style="text-transform: uppercase;">
                        </mat-form-field>

                        <mat-form-field class="form-group col-lg-4 col-md-4 col-sm-4 col-12">
                            <mat-label>Data Cancelamento</mat-label>
                            <input matInput value="Data Cancelamento" class="form-control"
                                id="dataCancelamentoFormatada" name="dataCancelamentoFormatada"
                                formControlName="dataCancelamentoFormatada">
                        </mat-form-field>
                    </div>

                    <div class="form-row" formGroupName="motivoCancelamento">
                        <mat-form-field class="form-group col-lg-12 col-md-12 col-sm-12 col-12">
                            <mat-label>Motivo Cancelamento</mat-label>
                            <input matInput value="Motivo Cancelamento" class="form-control" id="motivoCancelamento"
                                name="motivoCancelamento" formControlName="descricao"
                                style="text-transform: uppercase;">
                        </mat-form-field>
                    </div>

                    <div class="form-row">
                        <mat-form-field style="margin-top: 6.5px;"
                            class="form-group col-lg-12 col-md-12 col-sm-12 col-12">
                            <mat-label>Obs. Motivo do Cancelamento</mat-label>
                            <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize"
                                cdkAutosizeMinRows="2" cdkAutosizeMaxRows="3" formControlName="obsMotivoCancelamento"
                                name="obsMotivoCancelamento" id="obsMotivoCancelamento" maxlength="60"
                                style="text-transform: uppercase;"></textarea>
                        </mat-form-field>
                    </div>

                    <div class="menu-formulario">
                        <div class="menu-formulario-botoes">
                            <button type="button" mat-mini-fab color="primary" (click)="gotoList()" matTooltip="Voltar">
                                <mat-icon>west</mat-icon>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>